import React from 'react';
import { Icon } from './Icon.js';
export const IconLoader6Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C5.58579 1.5 5.25 1.16421 5.25 0.75C5.25 0.335786 5.58579 0 6 0C9.31371 0 12 2.68629 12 6C12 6.41421 11.6642 6.75 11.25 6.75C10.8358 6.75 10.5 6.41421 10.5 6Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconLoader6Fill12.js.map